import { lazy } from "react";

export { SURVEY_SCALE_PATH } from "./survey-scale-path";
export const SurveyScalePage = lazy(() => import("./survey-scale"));
